const DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
});

const TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
});

export const formatEmployeeFullName = (employee = {}) => {
    const fullName = [employee?.firstName, employee?.lastName]
        .filter(Boolean)
        .map((value) => String(value).trim())
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();

    return fullName;
};

export const buildTimestamp = (employee, date = new Date()) => {
    const formattedDateTime = `${DATE_FORMATTER.format(date)} ${TIME_FORMATTER.format(date)}`;
    const employeeFullName = formatEmployeeFullName(employee);

    return employeeFullName
        ? `${formattedDateTime} ${employeeFullName} - `
        : `${formattedDateTime} - `;
};

export const insertTimestampIntoText = (
    value = "",
    selectionStart,
    selectionEnd,
    employee,
) => {
    const safeValue = value ?? "";
    const start =
        typeof selectionStart === "number" ? selectionStart : safeValue.length;
    const end = typeof selectionEnd === "number" ? selectionEnd : start;
    const before = safeValue.slice(0, start);
    const after = safeValue.slice(end);
    const timestamp = buildTimestamp(employee);

    const needsBlankLineBefore = before.length > 0 && !before.endsWith("\n\n");
    const prefix = needsBlankLineBefore
        ? before.endsWith("\n")
            ? "\n"
            : "\n\n"
        : "";

    const insertion = `${prefix}${timestamp}`;

    return {
        caretPosition: start + insertion.length,
        value: before + insertion + after,
    };
};
